import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthProvider } from '../../providers/auth';
import { NewUserFinish } from '../../providers/user';
import { PlanesProvider } from '../../providers/planes';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
    selector: 'app-finish-sign-up',
    templateUrl: './finish-sign-up.component.html',
    styleUrls: ['./finish-sign-up.component.css']
})
export class FinishSignUpComponent implements OnInit {

    newUser: NewUserFinish;

    private _success = new Subject<string>();
    successMessage: string;

    activateSubmit: boolean = false;

    constructor(private navParams: ActivatedRoute, private _auth: AuthProvider, private _plan: PlanesProvider) { }

    ngOnInit() {
        this._auth.userPrevRegister = new NewUserFinish(this._auth.userPrev, null);
        this.newUser = this._auth.userPrevRegister;
        this._plan.find(this._auth.userPrev.plan).then(plan => {
            this._auth.userPrevRegister.plan = plan;
            this.newUser.plan = plan;
        });
        this._success.subscribe((message) => this.successMessage = message);
        this._success.pipe(
            debounceTime(5000)
        ).subscribe(() => this.successMessage = null);
    }

    changeData(key: string, val: string){
        switch(key){
            case 'name':
                if(val == '' || val.length < 3){
                    this._success.next('Rellene el campo nombre correctamente, minimo 3 caracteres');
                    this.activateSubmit = false;
                }else{
                    this.successMessage = null;
                    this.activateSubmit = true;
                }
                break;
            case '':
            default:
                break;
        }
    }

    changePass() {
        if (!(/^(?=\w*\d)(?=\w*[A-Z])(?=\w*[a-z])\S{6,16}$/).test(this.newUser.pass)) {
            this._success.next(`La contraseña debe ser entre 6-16 caracteres con minúsculas, mayúsculas y números.`);
            this.activateSubmit = false;
        } else {
            this.successMessage = null;
            this.repeatPass();
        }
    }

    onSubmitRegistro() {
        if(this.newUser.domicilio == '' || this.newUser.name == '' || this.newUser.nifCif == '' || this.newUser.telefono == ''){
            this._success.next('Rellene los datos correctamente.');
            this.activateSubmit = false;
            console.log(this.newUser);
        }else{
            this.successMessage = null;
            this.activateSubmit = true;
            this._auth.registerNewUser(this.newUser).then(s => console.log('register user', s));
        }
    }

    repeatPass() {
        if (this.newUser.pass !== this.newUser.passRepeat) {
            this._success.next(`Las contraseñas no coinciden.`);
            this.activateSubmit = false;
        } else {
            if(this.newUser.domicilio == '' || this.newUser.name == '' || this.newUser.nifCif == '' || this.newUser.telefono == ''){
                this._success.next('Rellene los datos correctamente.');
                this.activateSubmit = false;
                console.log(this.newUser);
            }else{
                this.successMessage = null;
                this.activateSubmit = true;
            }
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/pages/finish-sign-up/finish-sign-up.component.ts